// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".toc-content-tabs[data-v-b79479fe]{justify-content:center;margin-bottom:.75rem}.toc-content-tabs .button[data-v-b79479fe]{flex:1}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
